import React from 'react';

interface ProgramItem {
  image: string;
  title: string;
  ageRange: string;
  description: string;
  link: string;
  backgroundColor?: 'default' | 'bg-2' | 'bg-3' | 'bg-4';
}

interface KidsaProgramsProps {
  title?: string;
  subtitle?: string;
  programs: ProgramItem[];
}

const KidsaPrograms: React.FC<KidsaProgramsProps> = ({
  title,
  subtitle,
  programs
}) => {
  return (
    <section className="program-section section-padding section-bg-2 fix" id="programs">
      <div className="top-shape">
        <img src="/assets/kidsa/assets/img/section-top-shape.png" alt="shape-img" />
      </div>
      <div className="bottom-shape">
        <img src="/assets/kidsa/assets/img/section-bottom-shape.png" alt="shape-img" />
      </div>
      <div className="mask-shape float-bob-x">
        <img src="/assets/kidsa/assets/img/program/mask.png" alt="shape-img" />
      </div>
      <div className="pencil-shape">
        <img src="/assets/kidsa/assets/img/program/pencil.png" alt="shape-img" />
      </div>
      <div className="mask-shape-2">
        <img src="/assets/kidsa/assets/img/program/mask-2.png" alt="shape-img" />
      </div>
      <div className="compass-shape">
        <img src="/assets/kidsa/assets/img/program/compass.png" alt="shape-img" />
      </div>
      <div className="container">
        <div className="section-title text-center mt-60">
          <span className="wow fadeInUp text-transform-none">{subtitle}</span>
          <h2 
            className="wow fadeInUp text-transform-none" 
            data-wow-delay=".3s"
            dangerouslySetInnerHTML={{ __html: title || '' }}
          />
        </div>
        <div className="row">
          {programs.map((program, index) => (
            <div 
              key={index}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" 
              data-wow-delay={`.${(index + 3) * 0.1}s`}
            >
              <div className="program-box-items">
                <div className={`program-bg ${program.backgroundColor || ''}`}></div>
                <div className="program-image">
                  <img src={program.image} alt="img" />
                </div>
                <div className={`program-content text-center px-4 ${index === 2 ? 'style-2' : ''}`}>
                  <h4>
                    <a href={program.link}>{program.title}</a>
                  </h4>
                  <span>({program.ageRange})</span>
                  <p dangerouslySetInnerHTML={{ __html: program.description }}></p>
                  <a 
                    href={program.link} 
                    className={`arrow-icon ${index === 1 ? 'color-2' : ''}`}
                  >
                    <i className="fa-solid fa-arrow-right-long"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KidsaPrograms;